
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/iframe/[slug]/[question]",
      function () {
        return require("private-next-pages/iframe/[slug]/[question].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/iframe/[slug]/[question]"])
      });
    }
  